import { useQuery } from '@tanstack/react-query';
import { useFetch } from '@/hooks/useFetch';
import type { GetClientGroupedResponse } from '@/types/clientsApiTypes';

export const CLIENT_GROUPED_QUERY_KEY = 'client-grouped';

function buildGroupedUrl(clientIds: number[]): string {
  const params = new URLSearchParams();
  clientIds.forEach((id) => params.append('clients_id[]', String(id)));
  return `/api/clients/grouped?${params.toString()}`;
}

export const useGetClientGroupedQuery = (clientIds: number[]) => {
  const { doFetch } = useFetch<void, GetClientGroupedResponse>();

  return useQuery({
    queryKey: [CLIENT_GROUPED_QUERY_KEY, clientIds],
    queryFn: () => doFetch(buildGroupedUrl(clientIds), { method: 'GET' }),
    enabled: clientIds.length > 0,
  });
};
